
const AUTH = {
  GROUP: 1,
  CONTENT: 2,
  SECRETARIAT: 3,
  EVALUATION: 4,
  ADOPTION: 5,
};

const AUTH_TEXT = {
  1: 'グループ責任者',
  2: 'コンテンツ管理者',
  3: '事務局ユーザー',
  4: '選考評価担当者',
  5: '合否決定者',
};

const USER_TYPE = {
  GAS: 1,
  CMS: 2,
  // No.9 代行者（申請者と同じ /login を共用・ログイン後は専用プレースホルダーのみ）
  AGENT: 3,
  SYS: 9,
};

const USER_META = {
  1: ['gas'],
  2: ['cms'],
  // 代行者は (A) 段階では 'agent' ページ（プレースホルダー）のみ許可。実手続きは (B)
  3: ['agent'],
  9: ['gas', 'cms'],
};

export default {
  AUTH,
  AUTH_TEXT,
  USER_TYPE,
  USER_META,
};
